export default __webpack_public_path__ + "static/media/team-bj.5efd173b.jpg";